module.exports = __webpack_public_path__ + "static/img/function-box-img3.84be7e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedProcess/function-box-img3.png
// module id = 6CHI
// module chunks = 0